import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import React from 'react';
import Plans from '../LicenseKey/Plans';
import FreeFeatures from '../Common/FreeFeatures';
import PremiumFeatures from '../Common/PremiumFeatures';
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate } from 'react-router-dom';
import { setStoreData } from '../../store/auth';
import { API } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';

const promise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

export default function Subscriptions() {
  const [accountType, setAccountType] = useState('free');
  const [plans, setPlans] = useState({
    subscriptions: [],
    invoices: [],
    billings: {},
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { isAuthenticated, user, plan, tmpUser } = useSelector(
    (state) => state.auth.data || {}
  );

  const dispatch = useDispatch();

  useEffect(() => {
    console.log(isAuthenticated);
    if (isAuthenticated && user) {
      getPlanFromProps();
    } else if (!isAuthenticated) {
      navigate('/');
    }
    else if ((!user && tmpUser)) {
      // Account not verified yet
      setLoading(false);
    }
  }, []);

  const getPlanFromProps = function () {

    if (plan === null) {
      fetchPlans();

    } else {
      //local cache
      setPlans(plan);
      setLoading(false);
      setStateFromPlans(plan.subscriptions);
      // plan.subscriptions.forEach((element) => {
      //   setStateForElement(element);
      // });
    }
  };
  const fetchPlans = async () => {
    if (!user) return;
    const session = user.getSignInUserSession();

    const myInit2 = {
      queryStringParameters: {
        action: 'plan',
      },
      headers: {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      },
    };
    await API.get('HandLAPI', '/myaccount', myInit2)
      .then((response) => {
        setPlans(response);
        setStateFromPlans(response.subscriptions);

        if (response.subscriptions.length > 0) {
          dispatch(
            setStoreData({ data: { plan: response, AppEligible: false } })
          );

          let crispData = [];
          response.subscriptions.forEach((element, id) => {
            // setStateForElement(element);

            let license_key = element['license_key'];
            crispData.push([
              id + 1 + '_AccountType',
              getAccountStatus(element),
            ]);
            crispData.push([id + 1 + '_LicenseLast4', license_key]);
            crispData.push([
              id + 1 + '_Plan',
              element['plan_name'] ? element['plan_name'] : '',
            ]);
            crispData.push([
              id + 1 + '_PlanAmount',
              element['plan_amount'] ? element['plan_amount'] : '',
            ]);
            crispData.push([
              id + 1 + '_Start',
              element['subscription_date_start'],
            ]);
            crispData.push([
              id + 1 + '_End',
              element['subscription_date_end'] ? element['subscription_date_end'] : 'N/A',
            ]);
            crispData.push([id + 1 + '_PaysId', element['pays_id']]);
            crispData.push([
              id + 1 + '_LicenseNum',
              element['license_number'],
            ]);
            crispData.push([id + 1 + '_Used', element['domains'].length]);
            crispData.push([
              id + 1 + '_UsedSites',
              element['domains'].join('\n'),
            ]);
          });
          window.$crisp.push(['set', 'session:data', [crispData]]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log({ error });
        setLoading(false);
      });
  }
  const setStateFromPlans = (plans) => {
    let status = 'free';
    plans.forEach((plan) => {
      if (plan['subscription_status'].toLowerCase() === 'active' || plan["subscription_status"].toLowerCase() === "trialing" || plan["subscription_status"].toLowerCase() === "expiring"){
        status = 'paid';
        // dispatch(setStoreData({ data: { AppEligible: true } }));
      }
    });
    setAccountType(status);
    return status;
  };

  var getAccountStatus = function (element) {
    var account_status = 'paid';
    if (
      element['subscription_status'].toLowerCase() === 'canceled' ||
      element['subscription_status'].toLowerCase() === 'cancelled'
    ) {
      account_status = 'free';
    }
    return account_status;
  };
  return (
    <div id='license' className='container mx-auto'>
      <div className='row'>
        <div className='col-md-12 text-center'>
          {loading && (
            <div>
              <div className='fa-3x'>
                <i className='fa fa-spinner fa-spin'></i>
              </div>
              <p>Please wait while we are pulling your account data...</p>
            </div>
          )}
          {!loading && accountType == 'paid' && (
            <Elements stripe={promise}>
              <ElementsConsumer>
                {({ elements, stripe }) => (
                  <Plans
                    refetchPlans={fetchPlans}
                    plans={plans}
                    elements={elements}
                    stripe={stripe}
                    accountType={accountType}
                  />
                )}
              </ElementsConsumer>
            </Elements>
          )}
          {!loading && accountType == 'free' && (
            <div className='lg:flex md:flex sm:block offer-box'>
              <div className='col-md-6'>
                <div className='panel panel-default'>
                  <div className='panel-heading'>
                    <h3 className='my-4 text-[24px] font-medium'>
                      UTM Grabber V2 (FREE)
                    </h3>
                  </div>
                  <div className='panel-body greencheck nope text-left'>
                    <FreeFeatures />
                  </div>
                  <div className='panel-footer my-4'>
                    <a
                      className='btn btn-sm btn-primary py-3 cursor-pointer'
                      href='https://downloads.wordpress.org/plugin/handl-utm-grabber.latest-stable.zip'
                    >
                      Download
                    </a>
                  </div>
                </div>
              </div>

              <div className='col-md-6'>
                <div className='panel panel-success'>
                  <div className='panel-heading'>
                    <h3 className='my-4 text-[24px] font-medium'>
                      UTM Grabber V3
                    </h3>
                  </div>
                  <div className='panel-body greencheck text-left'>
                    <PremiumFeatures />
                  </div>
                  <div className='panel-footer my-4'>
                    <button
                      className='btn btn-sm btn-primary cursor-pointer'
                      onClick={() => navigate('/#prices')}
                    >
                      Upgrade Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
